import { useStore } from '@tanstack/react-form';
import { useMemo } from 'react';

import { useFieldContext, useFormContext } from './form';

const getErrorMessage = (error) => {
  if (typeof error === 'string') return error;
  if (Array.isArray(error)) {
    return error.map((err) => getErrorMessage(err)).join(', ');
  }
  return error.message;
};

export const useFieldErrors = () => {
  const form = useFormContext();
  const field = useFieldContext();

  const formErrors = useStore(
    form.store,
    (state) => state.errors[0]?.[field.name],
  );

  const error = useMemo(() => {
    if (!field.state.meta.isTouched) return;

    const errors = new Set();
    if (field.state.meta.errors.length) {
      field.state.meta.errors.forEach((error) => {
        errors.add(getErrorMessage(error));
      });
    }

    /**
     * Remove this after issue is closed: https://github.com/TanStack/form/issues/1460
     */
    if (formErrors?.length) {
      formErrors.forEach((error) => {
        errors.add(getErrorMessage(error));
      });
    }

    return errors.size > 0 ? Array.from(errors) : null;
  }, [field.state.meta.errors, field.state.meta.isTouched, formErrors]);

  return error;
};
